/**
 * Unit mappings for conversions
 */
export const units = {
    // DISTANCES
    'm': {
        cm: 'cm',
        m: 'm',
        km: 'km',
        in: 'cm',
        ft: 'm',
        mi: 'km',
    },
    'mi': {
        cm: 'in',
        m: 'ft',
        km: 'mi',
        in: 'in',
        ft: 'ft',
        mi: 'mi',
    },
    // WEIGHT
    'kg': {
        kg: 'kg',
        lbs: 'kg',
    },
    'lbs': {
        kg: 'lbs',
        lbs: 'lbs',
    },
    // SPEED
    'km/h': {
        'km/h': 'km/h',
        'm/min': 'km/h',
        'mph': 'km/h',
    },
    'm/min': {
        'km/h': 'm/min',
        'm/min': 'm/min',
        'mph': 'm/min',
    },
    'mph': {
        'km/h': 'mph',
        'm/min': 'mph',
        'mph': 'mph',
    },
    // DEGREE
    'C': { F: 'C', C: 'C', K: 'C' },
    'F': { F: 'F', C: 'F', K: 'F' },
    'K': { F: 'K', C: 'K', K: 'K' },
    // TIME
    'hh:mm:ss': { 'hh:mm:ss': 's', 's': 'hh:mm:ss' },
    'hh:mm': { 'hh:mm': 's', 's': 'hh:mm' },
    'mm:ss': { 'mm:ss': 's', 's': 'mm:ss' },
}

/**
 * Get the unit type matching the userUnits
 *
 * @param {string} unit - Unit provided
 * @returns {string|null} - The key matching the userUnits
 */
export const getUnitKey = (unit) => {
    const unitTypeMap = {
        // Weight
        kg: 'weight',
        lbs: 'weight',
        // Distance
        cm: 'distance',
        m: 'distance',
        km: 'distance',
        in: 'distance',
        ft: 'distance',
        mi: 'distance',
        // Speed
        'km/h': 'speed',
        'm/min': 'speed',
        mph: 'speed',
        // Temperature
        C: 'temperature',
        F: 'temperature',
        K: 'temperature',
        // Time
        'hh:mm:ss': 'time',
        'hh:mm': 'time',
        'mm:ss': 'time',
    }

    return unitTypeMap[unit] || null
}

/**
 * Get the final unit to display based on user preferences
 *
 * @param {string} unit - Unit provided (registered in the DB)
 * @param {string} userUnit - Configured unit in the user (in DB): "mi" or "m"
 * @returns {string} - The final unit which will be displayed
 */
export const getUserUnit = (unit, userUnit) => {
    if (units[userUnit] && units[userUnit][unit]) {
        return units[userUnit][unit]
    } else {
        console.warn(`Unit not managed in convert::getUserUnit() : unit [${unit}] / userUnit [${userUnit}]`)
        return units[unit]?.[unit] || unit
    }
}

/**
 * Get supported units by category
 */
export const getSupportedUnits = () => ({
    distance: Object.keys(units['m']),
    weight: Object.keys(units['kg']),
    speed: Object.keys(units['km/h']),
    temperature: Object.keys(units['C']),
    time: [...Object.keys(units['hh:mm:ss']), ...Object.keys(units['hh:mm']), ...Object.keys(units['mm:ss'])],
})
